// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill";
import $ from 'jquery'
import store from './utils/store/store'
import api from './api/api'
import Qs from './utils/qsPlugin'
import './assets/css/zui.min.css'
import './assets/lib/datetimepicker/datetimepicker.css'
import './assets/css/commen.less'
import './assets/js/jquery-3.2.1.min.js'
import './assets/js/wangEditor.min.js'
import './assets/css/wangEditor.css'
import VueI18n from 'vue-i18n' 
import './assets/lang/zh'
import './assets/lang/en'
import VClamp from 'vue-clamp'
import moment from 'moment'; 
moment.locale('zh-cn');
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import anime from 'animejs/lib/anime.min.js';

Vue.prototype.$anime = anime;

// import './assets/js/socket.js'




window.jQuery=jQuery //此处尤为重要
require("./assets/js/zui.js")
require("./assets/lib/datetimepicker/datetimepicker.min.js")
require("./assets/lib/chosen/chosen.min.js")
// require("./assets/js/socket.js")

Vue.config.productionTip = false
Vue.prototype.$moment = moment;

Vue.use(Qs)
Vue.use(api)
Vue.use(VueI18n) 
Vue.component('VClamp', VClamp);
Vue.use(ElementUI);

const i18n = new VueI18n({
  locale: 'zh', 
  messages:{
    'zh': require('./assets/lang/zh'),
    'en': require('./assets/lang/en')
  }
});



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})
//红点淡入淡出
if($('.newsdot').css('display') != 'none'){
  setInterval(function(){  
    $(".newsdot").fadeTo(600,0.1).fadeTo(800,1); 
  },1400);
}



// WEBPACK FOOTER //
// ./src/main.js